import { render } from "./CukaiTertunggak.vue?vue&type=template&id=19cb9a06"
import script from "./CukaiTertunggak.vue?vue&type=script&lang=js"
export * from "./CukaiTertunggak.vue?vue&type=script&lang=js"

import "./CukaiTertunggak.vue?vue&type=style&index=0&id=19cb9a06&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__